export const LIBERAL_ARTS_URL = window.location.origin
  .replace("staff.", "")
  .concat("/liberal_arts");
